import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import SelectLeaveForm from "./SelectLeaveForm";
import Breadcrumb from "../../components/Common/Breadcrumb";
import ReportType from "./LeaveReport/ReportType";
import SelectReport from "./LeaveReport/SelectReport";
import axios from "axios";
import TableApprove from "./WaitApprove/TableApprove";
import { GetCookieData, GetCookieToken, GetUserInfo } from "../Cookie/GetCookie";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import classnames from "classnames";
import LoadingData from "../TESTPage/LoadingData";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import SubMenuLeave from "./SubMenuLeaveOnline";
import { CheckBudgetYear } from "../Function/CheckBudgetYear";
import TableForm from "./TableForm";
import backgroundChart1 from "../../assets/images/bg-chart1.png";
import backgroundChart2 from "../../assets/images/bg-chart2.png";
import backgroundChart3 from "../../assets/images/bg-chart3.png";
import backgroundChart4 from "../../assets/images/bg-chart4.png";

const LarOnline = () => {
  document.title = "การลาออนไลน์ | Flexible-Time";

  const baseURL = process.env.REACT_APP_API_CORS;
  // const userApproveForPSED = Number(process.env.REACT_APP_USER_APPROVE_FOR_PSED);
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  const user_position = GetCookieData("userPosition");
  
  const location = useLocation();
  const paramValue = new URLSearchParams(location?.search).get("exitbefore") || "";
  const paramValue2 = new URLSearchParams(location?.search).get("formID") || "";
  const leaveID = new URLSearchParams(location?.search).get("leaveID") || "";
  const user_info = GetUserInfo(baseURL, token);


  const navigate = useNavigate();

  const areULeader = (positionArr) => {
    if (positionArr.length === 0) return false;
    if (
      positionArr.find((item) => item.position_id >= 2 && item.position_id <= 7)
    )
      return true;
  };

  const [disable, setDisable] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  const currentBudgetYear = CheckBudgetYear();
  const [selectBudgetYear, setSelectBudgetYear] = useState(CheckBudgetYear());
  const [loading, setLoading] = useState(false);
  const [userEmp, setUserEmp] = useState([]);
  const [loadingChart, setLoadingChart] = useState(true);
  const [selectReport, setSelectReport] = useState("1");
  const [leaveData, setLeaveData] = useState([]);
  const [activeTabNav, setActiveTabNav] = useState(
    areULeader(user_position) || (user_id === userInfo?.psac_user_approve?.approve_user_id) ? "1" : "2"
  );
  const [leavePagination, setLeavePagination] = useState({
    currentPage: 0,
    totalPage: 0,
    totalRows: 0,
  });
  const [allDayLeaveType, setAllDayLeaveType] = useState({
    sick_leave: 0, //จำนวนวันลาป่วย 1
    personal_leave: 0, ///จำนวนวันลากิจ 1
    maternity_leave: 0, //จำนวนวันลาคลอดบุตร 1
    vacation_leave: 0, //จำนวนวันลาพักผ่อน 2
    vacation_leave_total: 0, //จำนวนวันลาพักผ่อน 2 (คงเหลือ)
    abroad_leave: 0, //จำนวนวันลาไปต่างประเทศ 3
    ordinate_leave: 0, //จำนวนวันลาป่วย 4
    hajj_leave: 0, //จำนวนวันลาพิธีฮัจ 5
    conscription_leave: 0, //จำนวนวันลาการเตรียมพล 6
    training_leave: 0, //จำนวนวันลาลาไปศึกษา ฝึกอบรม ดูงาน 7
    spouse_leave: 0, //จำนวนวันลาติดตามคู่สมรส 8
    outside_leave: 0, //จำนวนวันลาไปปฏิบัติราชการนอกสำนักงาน 9
    practice_leave: 0, //จำนวนวันลารับรองการมาปฎิบัติราชการ 10
    parenting_leave: 0, //จำนวนวันลากิจส่วนตัวเพื่อเลี้ยงดูบุตร 11
    helpparenting_leave: 0, //จำนวนวันลาไปช่วยเหลือภรรยาที่คลอดบุตร 11
    rehabilitation_leave: 0, //จำนวนวันลาไปฟื้นฟูสมรรถภาพด้านอาชีพ 11
  });

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserInfo(res?.data?.result);
      } catch (err) {
        // console.error(err);
      }
    };
    setTimeout(() => {
      setLoading(true);
    }, 1000);
    getUserInfo();
    getLeaveChart(CheckBudgetYear())
    getLeaveData();
  }, []);

  // useEffect(() => {
  //   setViewSubMenu(
  //     CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) 
  //   );
  // }, [userInfo]);


  useEffect(() => {
    if (leaveID) {
      const id = atob(leaveID);
      const idData = id.split("^");
      const thisUseEffect = async () => {
        const url = baseURL + `/api/leave/datatable`;
        const params = new URLSearchParams({
          page: 1,
          size: 1,
          "order[0]": "created_date",
          "order[1]": "DESC",
          "filter[leave_data_id][0]": idData[1],
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const result = (await axios.get(url, config))?.data?.result?.[0];
        if (result.user_id === user_id) {
          navigate("/leave/tableleave?menu=leavedatatable");
        } else {
          navigate("/leave/tableleave?menu=allowleaveorder");
        }
      }
      thisUseEffect();
    }
  }, [userInfo]);

  const getUserEmployee = async (id) => {
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 1000,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[cont_to_id][0]": id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setUserEmp(res?.data?.result);
    } catch (err) { }
  };

  const toggleNav1 = (tab) => {
    if (activeTabNav !== tab) {
      setActiveTabNav(tab);
    }
  };

  const getLeaveChart = async (budgetYear) => {
    try {
      setLoadingChart(true);
      const res = await axios.get(
        baseURL + `/api/leave/chart/1/${budgetYear}/${user_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const insteadRes = res?.data?.result;      
      
      setAllDayLeaveType((prev) => ({
        ...prev,
        sick_leave: insteadRes?.sick_limit_day?.use,
        personal_leave: insteadRes?.personal_limit_day?.use,
        maternity_leave: insteadRes?.maternity_limit_day?.use,
        vacation_leave: insteadRes?.vacation_limit_day?.use,
        vacation_leave_total:
          insteadRes?.years_worked >= 10
            ? (insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_over10?.vacation_day_prev || 0)) > 30
              ? 30 : insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_over10?.vacation_day_prev || 0)
            : (insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_under10?.vacation_day_prev || 0)) > 20 
              ? 20 : insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_under10?.vacation_day_prev || 0),
        abroad_leave: insteadRes?.abroad_limit_day?.use,
        ordinate_leave: insteadRes?.ordinate_limit_day?.use,
        hajj_leave: insteadRes?.hajj_limit_day?.use,
        conscription_leave: insteadRes?.conscription_limit_day?.use,
        training_leave: insteadRes?.training_limit_day?.use,
        spouse_leave: insteadRes?.spouse_limit_day?.use,
        outside_leave: insteadRes?.outside_limit_day?.use,
        practice_leave: insteadRes?.practice_limit_day?.use,
        parenting_leave: insteadRes?.parenting_limit_day?.use,
        helpparenting_leave: insteadRes?.helpparenting_limit_day?.use,
        rehabilitation_leave: insteadRes?.rehabilitation_limit_day?.use,
      }));
      setTimeout(() => {
        setLoadingChart(false);
      }, 1000);
    } catch (err) {
      // console.error(err);
    }
  };

  const getLeaveData = async (
    page = 1,
    isFromIndex = true,
    budgetYear = CheckBudgetYear()
  ) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: page,
        size: isFromIndex ? 5 : 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[budget_year][0]": budgetYear,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveData(res?.data?.result);
      setLeavePagination((prev) => ({
        ...prev,
        currentPage: res?.data?.info?.currentPage,
        totalPage: res?.data?.info?.totalPage,
        totalRows: res?.data?.info?.totalRows,
      }));
    } catch (err) {
      // console.error(err);
    }
  };

  const RefreshLeaveDataTable = async (isFromIndex) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: isFromIndex ? 5 : 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[budget_year][0]": CheckBudgetYear(),
        // "filter[leave_status][0]": 2,
        // "filter[leave_status][1]": 3,
        // "filter[leave_status][2]": 4,
        // // "filter[leave_status][3]": 7,
        // "filter[leave_status][4]": 9,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveData(res?.data?.result);
      setLeavePagination((prev) => ({
        ...prev,
        currentPage: res?.data?.info?.currentPage,
        totalPage: res?.data?.info?.totalPage,
        totalRows: res?.data?.info?.totalRows,
      }));
    } catch (err) {
      // console.error(err);
    }
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (userInfo && (CheckPosition(userInfo?.position).length > 0 &&
        (CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 &&
        (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || 
          CheckSubAdmin(userInfo?.positionSubAdmin).includes(1))))) {
            setSelectReport(null)
    }
  }, [userInfo])
  

  return (
    <div className="page-content">
      {!loading ? (
        <LoadingPage />
      ) : (
        <FadeIn>
          <Container fluid>
            {/* {viewSubMenu && <SubMenuLeave />} */}
            {(CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(1))) && <SubMenuLeave />}

            <Breadcrumb
              title="หน้าหลัก"
              breadcrumbItem="การลาออนไลน์"
              home={true}
            />
            <Row>
              <Col xxl={12}>
                <Row className="">
                  <Col xxl={8}>
                    <Row className="d-flex align-items-center justify-content-end mb-2">
                      <Label
                        className="text-end font-size-18 me-0 pe-0"
                        md={2}
                        sm={3}
                        xs={8}
                      >
                        ปีงบประมาณ
                      </Label>
                      <Col md={2} sm={3} xs={4}>
                        <Input
                          type="select"
                          value={selectBudgetYear}
                          onChange={async (e) => {
                            setSelectBudgetYear(e.target.value);
                            getLeaveChart(e.target.value);
                            getLeaveData(1, true, e.target.value);
                          }}
                        >
                          <option value={currentBudgetYear - 0}>
                            {currentBudgetYear - 0}
                          </option>
                          <option value={currentBudgetYear - 1}>
                            {currentBudgetYear - 1}
                          </option>
                          <option value={currentBudgetYear - 2}>
                            {currentBudgetYear - 2}
                          </option>
                          <option value={currentBudgetYear - 3}>
                            {currentBudgetYear - 3}
                          </option>
                          <option value={currentBudgetYear - 4}>
                            {currentBudgetYear - 4}
                          </option>
                          <option value={currentBudgetYear - 5}>
                            {currentBudgetYear - 5}
                          </option>
                        </Input>
                      </Col>
                    </Row>
                    {loadingChart ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: "100px",
                        }}
                      >
                        <LoadingData />
                      </div>
                    ) : (
                      <FadeIn>
                        <React.Fragment>
                          <Row>
                            <Col lg={3} sm={6} xs={12} className="">
                              <div className="laonline-chart-background">
                                <Row
                                  id="chart1"
                                  className="laonline-chart-body p-0 m-0"
                                  // style={{backgroundImage:`url(${backgroundChart1})`, backgroundSize: '100% auto'}}
                                  style={{ backgroundImage: `url(${backgroundChart1})`, backgroundSize: '100% 100%' }}
                                //d-flex flex-column justify-content-evenly
                                >
                                  <Col
                                    xl={9}
                                    xs={8}
                                    className="d-flex flex-column justify-content-evenly text-black p-2"
                                  >
                                    <h6>ลาอุปสมบท </h6>
                                    <h6>ประกอบพิธีฮัจญ์ </h6>
                                    <h6>ลากรณีพิเศษ</h6>
                                    <h6>ติดตามคู่สมรส</h6>
                                  </Col>
                                  <Col className="d-flex flex-column justify-content-evenly align-items-end text-black p-2">
                                    <h6>
                                      {`${allDayLeaveType?.ordinate_leave} วัน` ||
                                        "ไม่มีข้อมูล"}
                                    </h6>
                                    <h6>
                                      {`${allDayLeaveType?.hajj_leave} วัน` ||
                                        "ไม่มีข้อมูล"}
                                    </h6>
                                    <h6>
                                      {`${((allDayLeaveType?.parenting_leave ?? 0) + (allDayLeaveType?.helpparenting_leave ?? 0) + (allDayLeaveType?.rehabilitation_leave ?? 0))} วัน` ||
                                      "ไม่มีข้อมูล"}
                                    </h6>
                                    <h6>
                                      {`${allDayLeaveType?.spouse_leave} วัน` ||
                                      "ไม่มีข้อมูล"}
                                    </h6>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={3} sm={6} xs={12} className="">
                              <div className="laonline-chart-background">
                                <Row
                                  id="chart2"
                                  className="laonline-chart-body p-1 m-0 d-flex justify-content-center"
                                  style={{ backgroundImage: `url(${backgroundChart2})`, backgroundSize: '100% 100%' }}
                                //d-flex flex-column justify-content-evenly
                                >
                                  <Col
                                    xl={9}
                                    xs={8}
                                    className="d-flex flex-column justify-content-evenly text-dark p-2"
                                  >
                                    <h6>ศึกษา/ฝึกอบรม</h6>
                                    <h6>ไป ตปท.</h6>
                                    <h6>ปฏิบัตินอกสำนักงาน</h6>
                                    <h6>เข้ารับเตรียมพล</h6>
                                  </Col>
                                  <Col className="d-flex flex-column justify-content-evenly align-items-end text-dark p-2">
                                    <h6>
                                      {`${allDayLeaveType?.training_leave} วัน` ||
                                        "ไม่มีข้อมูล"}
                                    </h6>
                                    <h6>
                                      {" "}
                                      {`${allDayLeaveType?.abroad_leave} วัน` ||
                                        "ไม่มีข้อมูล"}
                                    </h6>
                                    <h6>
                                      {" "}
                                      {`${allDayLeaveType?.outside_leave} วัน` ||
                                        "ไม่มีข้อมูล"}
                                    </h6>
                                    <h6>
                                      {" "}
                                      {`${allDayLeaveType?.conscription_leave} วัน` ||
                                        "ไม่มีข้อมูล"}
                                    </h6>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={3} sm={6} xs={12} className="" >
                              <div className="laonline-chart-background" >
                                <div
                                  id="chart3"
                                  className="laonline-chart-body"
                                  style={{ backgroundImage: `url(${backgroundChart3})`, backgroundSize: '100% 100%' }}
                                >
                                  <div
                                    style={{
                                      height: "100%",
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        position: "absolute",
                                        padding: "15px",
                                      }}
                                    >
                                      <h2 className="m-0 p-0">
                                        ลากิจ{" "}
                                        {`${allDayLeaveType?.personal_leave} วัน` ||
                                          "ไม่มีข้อมูล"}
                                      </h2>
                                    </div>
                                    <div
                                      className=""
                                      style={{
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "end",
                                        alignItems: "end",
                                        padding: "15px",
                                      }}
                                    >
                                      <h2 className="m-0 p-0">
                                        ลาป่วย{" "}
                                        {`${allDayLeaveType?.sick_leave} วัน` ||
                                          "ไม่มีข้อมูล"}
                                      </h2>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col lg={3} sm={6} xs={12}>
                              <div className="laonline-chart-background">
                                <div
                                  id="chart4"
                                  className="laonline-chart-body"
                                  style={{ backgroundImage: `url(${backgroundChart4})`, backgroundSize: '100% 100%' }}
                                >
                                  <div
                                    style={{
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <h3>ลาพักผ่อน</h3>
                                    <h1>
                                      {`${allDayLeaveType?.vacation_leave} วัน` ||
                                        "ไม่มีข้อมูล"}
                                      /{`${allDayLeaveType?.vacation_leave_total || 0}`} วัน
                                    </h1>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </React.Fragment>
                      </FadeIn>
                    )}
                    <Row className="mt-3">
                      <Col xl={12}>
                        <Row className="row align-items-end">
                          <Col md={3} xl={6} >
                            <Nav pills className="navtab-bg">
                              {userInfo &&
                               (((CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && 
                                  (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || 
                                   CheckSubAdmin(userInfo?.positionSubAdmin).includes(1))) 
                                || CheckPosition(userInfo?.position).length > 0) || (user_id === userInfo?.psac_user_approve?.approve_user_id) ) &&
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTabNav === "1",
                                    })}
                                    onClick={() => {
                                      toggleNav1("1");
                                    }}
                                  >
                                    รออนุมัติ
                                  </NavLink>
                                </NavItem>
                              }
                              {!(userInfo?.position?.find((x) => x?.position_id === 2)) && <NavItem>
                                <NavLink
                                  className={classnames({
                                    active: activeTabNav === "2",
                                  })}
                                  onClick={() => {
                                    toggleNav1("2");
                                  }}
                                >
                                  รายการลา
                                </NavLink>
                              </NavItem>}
                            </Nav>
                          </Col>
                          <Col
                            xl={6}
                            md={9}
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "end",
                            //   alignItems: "center",
                            // }}
                            className={` 
                              ${windowSize.width < 576 
                                || (windowSize.width >= 576 && windowSize.width < 992 ) 
                                || (windowSize.width >= 992 && windowSize.width < 1200 )
                                  ? "mt-2" 
                                  : ""
                                }
                            `}
                          >
                            <Row className={(userInfo?.position?.find((x) => x?.position_id === 2)) && "d-flex justify-content-end pe-3"}>
                              <Col xl={8} md={9} sm={7} xs={12} className="pe-0">
                                {activeTabNav === "1" ? (
                                  <div style={{ textAlign: windowSize.width < 576 ? "start" : (windowSize.width >= 576 && windowSize.width <= 767) ? "start" : "end" }}>
                                    <Button
                                      color="primary"
                                      className="pb-0"
                                      onClick={() => {
                                        navigate(
                                          "/leave/tableleave?menu=allowleaveorder"
                                        );
                                      }}
                                    >
                                      <h6>
                                        <b className="ms-1 font-size-18" style={{whiteSpace: "nowrap"}}>
                                          ตรวจสอบประวัติการอนุมัติ
                                          <i className="fa-solid fa-right-long ms-1"></i>
                                        </b>{" "}
                                      </h6>
                                    </Button>
                                  </div>
                                ) : (
                                  <div style={{ textAlign: windowSize.width < 576 ? "start" : (windowSize.width >= 576 && windowSize.width <= 767) ? "start" : "end"  }}>
                                    <Button
                                      color="primary"
                                      className="pb-0"
                                      onClick={() => {
                                        navigate(
                                          "/leave/tableleave?menu=leavedatatable"
                                        );
                                      }}
                                    >
                                      <h6>
                                        <b className="ms-1 font-size-18">
                                          ตรวจสอบประวัติการลา
                                          <i className="fa-solid fa-right-long ms-1"></i>
                                        </b>{" "}
                                      </h6>
                                    </Button>
                                  </div>
                                )}  
                              </Col>

                              {!(userInfo?.position?.find((x) => x?.position_id === 2)) && <Col xl={4} md={3} sm={5} xs={12} className={` 
                                  ${windowSize.width < 576 ? "mt-2" : (windowSize.width >= 576 && windowSize.width <= 767) ? "d-flex justify-content-end" : "ps-0 d-flex justify-content-end"
                                    }
                                `}>
                                
                                <SelectLeaveForm
                                    activeTabNav={activeTabNav}
                                    setActiveTabNav={setActiveTabNav}
                                    paramValue={paramValue}
                                    paramValue2={paramValue2}
                                    RefreshLeaveDataTable={RefreshLeaveDataTable}
                                    userInfo={userInfo}
                                    isFromIndex={true}
                                  />
                              </Col>}
                            </Row>
                          </Col>
                          <Col xxl={12}>
                            <TabContent activeTab={activeTabNav}>
                              <TabPane tabId="2">
                                <TableForm
                                  isFromIndex={true}
                                  selectRow={5}
                                  userInfo={userInfo}
                                  leaveData={leaveData}
                                  leavePagination={leavePagination}
                                  setLeaveData={setLeaveData}
                                  setLeavePagination={setLeavePagination}
                                  getLeaveData={getLeaveData}
                                  RefreshLeaveDataTable={RefreshLeaveDataTable}
                                  SelectBudgetYear={selectBudgetYear}
                                />
                              </TabPane>
                              <TabPane tabId="1">
                                <TableApprove
                                  isFromIndex={true}
                                  selectRow={5}
                                  budgetYear={selectBudgetYear}
                                />
                              </TabPane>
                            </TabContent>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xxl={4} xl={12}>
                    <Card style={{ minHeight: "450px" }}>
                      <CardBody className="pb-0">
                        <Row
                          className=""
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Col className="">
                            <Badge color="primary" className="pb-0">
                              <h5 className="font-size-16 card-title mb-0 p-2">
                                <i className="fa-solid fa-clipboard-list-check font-size-16 me-2"></i>
                                รายงานการลา
                              </h5>
                            </Badge>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Row
                              className="mt-3"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                              }}
                            >
                              <Label className="text-end" xxl={3} xl={4} xs={4}>
                                ประเภทรายงาน
                              </Label>
                              <Col xxl={6} xl={5} xs={7}>
                                <Input
                                  type="select"
                                  // disabled={disable}
                                  onChange={(e) => {
                                    setSelectReport(e?.target?.value);
                                  }}
                                >
                                  {
                                  // CheckPosition(userInfo?.position).length > 0 ||
                                    (CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 &&
                                    (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || 
                                     CheckSubAdmin(userInfo?.positionSubAdmin).includes(1))) ? (
                                      <>
                                        <option value={null}>กรุณาระบุ</option>
                                        {ReportType?.map((item, idx) => {
                                          return (
                                            <option key={idx} value={item?.no}>
                                              {item?.name}
                                            </option>
                                          );
                                        })}
                                      </>
                                  ) : (
                                    <option value={1}>บัตรวันลา</option>
                                  )}
                                </Input>
                              </Col>
                            </Row>
                            {selectReport && (
                              <SelectReport
                                budgetYear={currentBudgetYear}
                                userEmp={userEmp}
                                getUserEmployee={getUserEmployee}
                                idReport={selectReport}
                              />
                            )}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </FadeIn>
      )}
    </div>
  );
};

export default LarOnline;
